import { IconPropsType } from '..';

export const LiveDealerColoredIcon = ({ ...props }: IconPropsType) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.89127 15.1879L5.04065 5.59815C4.85061 5.25456 4.47053 5.08277 4.02726 5.19744L3.07706 5.48391C2.76016 5.54117 2.57012 5.8275 2.57012 6.11397L2 15.3601C2 15.761 2.31689 16.0473 2.69698 16.1046H7.13111C7.57438 16.1046 7.89127 15.8179 7.89127 15.4174C7.95446 15.3601 7.89127 15.245 7.89127 15.1879ZM15.3665 6.11354C15.3665 5.82721 15.1765 5.59815 14.8598 5.48362L13.9095 5.14003C13.5295 5.02522 13.086 5.19701 12.9593 5.5406L10.1087 15.1303C9.98172 15.4739 10.2354 15.8748 10.6155 15.9893C10.6789 15.9893 10.7424 16.0466 10.8689 16.0466H15.2398C15.6829 16.0466 16 15.76 16 15.3594L15.3665 6.11354Z"
        fill="#E2E3E4"
      />
      <path
        d="M11.4253 2.03506H11.6425C12.0769 2.03506 12.5111 2.37582 12.5111 2.85249V4.55547C12.3663 5.03196 11.9319 5.30478 11.4251 5.16854L8.96399 4.14675L6.5749 5.16854H6.35771C5.92333 5.16854 5.48895 4.8276 5.48895 4.35111V2.64813C5.56153 2.17147 6.06813 1.89882 6.5025 2.03506L8.96381 2.85249L11.4253 2.03506Z"
        fill="currentColor"
      />
    </svg>
  );
};
